import client from './client'

export const getJobs = (filters) => client.get('/jobs', { params: filters })
export const applierGetJobs = (filters) => client.get('/jobs/applier/search', { params: filters });

export const getJob = (id) => client.get(`/jobs/${id}`)
export const createJob = (data) => client.post('/jobs', data)
export const updateJob = (id, data) => client.put(`/jobs/${id}`, data)
export const deleteJob = (id) => client.delete(`/jobs/${id}`)

// Apply to a job using the dedicated applier endpoint
// The backend expects { jobId, coverLetter?, whyMe?, telegramUsername?, telegramPhone? }
export const applyJob = (jobId, data = {}) =>
  client.post('/applier/apply', { jobId, ...data })

export const getMyApplications = () => client.get('/applier/applications')
export const getApplicants = (jobId) => client.get(`/recruiter/jobs/${jobId}/applicants`)
export const updateApplicationStatus = (jobId, userId, status) =>
  client.patch(`/recruiter/jobs/${jobId}/applicants/${userId}`, { status })

// Get jobs posted by the current recruiter
export const getMyJobs = () => client.get('/recruiter/myjobs')

// Upload a resume
export const uploadResume = (fileData) => {
  const formData = new FormData() 
  formData.append('resume', fileData)
  return client.post('/applier/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const toggleSavedJob = async (jobId) => {
  try {
    const savedJobs = await client.get('/applier/saved');
    const isAlreadySaved = (savedJobs.data || []).some(j => (j.jobId === jobId || j.id === jobId));
    
    if (isAlreadySaved) {
      await client.delete(`/applier/save/${jobId}`);
      return { isSaved: false };
    } else {
      await client.post('/applier/save', { jobId });
      return { isSaved: true };
    }
  } catch (error) {
    throw error;
  }
};

export const checkJobSaved = async (jobId) => {
  try {
    const savedJobs = await client.get('/applier/saved');
    return (savedJobs.data || []).some(j => (j.jobId === jobId || j.id === jobId));
  } catch (error) {
    return false;
  }
};

// Check whether the current applier has already applied to a given job
export const checkJobApplied = async (jobId) => {
  const res = await client.get(`/applier/applications/check/${jobId}`);
  return res.data?.hasApplied ?? false;
};